import { useState } from "react";
import AdminOtpVerify from "./PasswordOtpVerify";
import ChangePasswordWithOtp from "./ChangePasswordWithOtp";
import {
  Box,
  Modal,
} from '@mui/material';
import ReusableModal from "../MUIComponent/Utlis/Modal/Modal";
import { useTranslation } from 'react-i18next';
const ChangePasswordModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState(null);

  const handleClose = () => {
    
    setStep(1);
    setFormData(null);

  
    onClose();
  };

  return (
    <ReusableModal
      open={open}
      onClose={handleClose}
      title={t('header.changePassword')}
    >
      <Box>
        {step === 1 && (
          <ChangePasswordWithOtp
            setStep={setStep}
            setFormData={setFormData}
            onClose={handleClose}
          />
        )}

        {step === 2 && (
          <AdminOtpVerify
            formData={formData}
            onClose={handleClose} // ✅ important
          />
        )}
      </Box>
    </ReusableModal>
  );
};

export default ChangePasswordModal;
